import CoreSelect from '@/components/Form/SelectAntForm';
import { useCoreContext } from '@/core';
import { get } from 'lodash';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
}

export const BusinessUnitCategoryPicker = (props: Props) => {
  const { className } = props;
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { categoryList } = useCoreContext();

  return (
    <CoreSelect
      control={control}
      name='categoryIds'
      label={t('common.category')}
      mode='multiple'
      required
      optionsProps={categoryList ?? []}
      displayField='name'
      valueField='id'
      className={className}
      filterOption={(inputValue, option) => {
        if (option) {
          return String(get(option, 'label')).toLowerCase().includes(inputValue.toLowerCase());
        }
        return true;
      }}
    />
  );
};
